/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var formatUserNamesLastFirst = require('common/util/formatUserNamesLastFirst');
var GetUsersForRole = require('common/services/GetUsersForRole');

var GetRecord = require('../../common/services/GetRecord');
var GetAllRecordLookups = require('../../common/services/GetAllRecordLookups');
var CorpFinInvestmentEditView = require('../views/CorpFinInvestmentEditView');

module.exports = function(recordId, invHistoryId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetRecord(recordId), GetAllRecordLookups('Investment'), GetUsersForRole('CF - Examiner'))
    .done(function(record, lookups, examiners) {
      NavUtils.navigate('corpfin/investment/' + recordId + '/edit-details');
      examiners = formatUserNamesLastFirst(examiners);
      Scaffold.content.show(
        new CorpFinInvestmentEditView({
          viewMode: 'int',
          model: new Backbone.Model({
            recordId: recordId,
            record: record,
            fileTypes: lookups.recordTypes,
            statuses: lookups.recordStatuses,
            entityTypes: lookups.entityTypes,
            offeringTypes: lookups.offeringTypes,
            examiners: examiners
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
